import React from "react";
import { usePendingPrefill, useSetDefaultValue } from "@hooks";
import { PrefillInput } from "@components/input";
import { FIELD_NAMES } from "../../../../constants/commonConstants";
import { useIncrementSnapper, useProductTypeIncrement } from "@hooks/inputIncrement";

const LoanAmountInput = () => {
  useSetDefaultValue(FIELD_NAMES.LOAN_AMOUNT);
  usePendingPrefill(FIELD_NAMES.LOAN_AMOUNT);

  const increment = useProductTypeIncrement();
  const [ref, onBlur] = useIncrementSnapper(FIELD_NAMES.LOAN_AMOUNT);

  return (
    <PrefillInput
      ref={ref}
      title="Loan Amount"
      type="number"
      placeholder="Enter Loan Amount"
      prefix={<span>$</span>}
      maxLength={5}
      name={FIELD_NAMES.LOAN_AMOUNT}
      toolTipText={`Please enter a value which fits within an increment of ${increment}`}
      onBlur={onBlur}
    />
  );
};

export default LoanAmountInput;
